/*
 * View for UI Configurations
 */

define([
  "marionette",
  "./template/uiConfigTemplate.html",
  "./template/uiConfigItemTemplate.html",
], function (Marionette, UIConfigTemplate, UIConfigItemTemplate) {
  var UIConfigView = {};

  UIConfigView.uiConfigItemView = Marionette.ItemView.extend({
    className: "ui-config-item standard-shaded-border",
    template: UIConfigItemTemplate,
    modelEvents: {
      change: "render",
    },
    triggers: {
      "click #deleteUIConfig": "delete:config",
      click: "edit:config",
    },
  });

  UIConfigView.uiConfigView = Marionette.CompositeView.extend({
    template: UIConfigTemplate,
    itemView: UIConfigView.uiConfigItemView,
    itemViewContainer: "#uiConfigsList",
    triggers: {
      "click #addUIConfig": "add:config",
    },
  });

  return UIConfigView;
});
